// // 在这里全局注册不生效，搬到了main.ts中
// import { createApp } from 'vue'
// import SvgIcon from '@/components/SvgIcon.vue' // svg组件

// // 注册到全局
// const app = createApp()
// // 将SvgIcon.vue组件注册为全局组件
// app.component('SvgIcon', SvgIcon)

// 遍历require.context的返回模块，并导入
const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)